/**
 * Operations Kanban Page
 *
 * Standalone route for the projects/quotes Kanban board. Extracted from the
 * Operations Dashboard's "Kanban" tab into its own page at
 * /operations/dashboard/kanban.
 */

import { ProjectsKanbanView } from '../components/ProjectsKanbanView';

export function OperationsKanbanPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Operations Kanban</h1>
        <p className="text-muted-foreground">
          Projects and quotes in Kanban view
        </p>
      </div>
      <ProjectsKanbanView />
    </div>
  );
}
